// extracted by mini-css-extract-plugin
export default {"cardList":"AnalyticSizingCards_cardList__RHP0+","card":"AnalyticSizingCards_card__7XvFD"};